export default class BetBuilderMarketModel {
    /**
     * class constructor method
     * @param data
     */
    constructor(data) {
        /**
         * Bet id
         * @type {number}
         */
        this.id = data.Id;
        /**
         * The textual representation of the market
         * @type {string}
         */
        this.label = data.Label;
        /**
         * The Id of the label
         * @type {number}
         */
        this.labelId = data.LabelId;
        /**
         * Indicates if the market has multiple selection
         * @type {boolean}
         */
        this.multipleSelection = data.MultipleSelection;
        /**
         * Raw Filter object from sportcast
         */
        this.Filter = data.Filter;
    }
}
